export const roleGroups = {
  prefix: "bl312-licensing-",
  names: { admin: "admin" },
};
